import { findIndex, filter } from "lodash";
window.nuanceCallback = {};
export function loadNuanceScript(user, setNuanceState, isNuanceEnabled) {
    // if script already loaded then return
    if(global.NUANCE_SCRIPT_LOADED) return;

    // add NUSA_configure method to window so it can be called by the script
    window.NUSA_configure =  function () {
        window.NUSA_userId = user.username;
        window.NUSA_applicationName = user.practice.nuance_app_name;
        window.NUSA_Guids = user.practice.nuance_org_token + "/" + user.practice.nuance_org_id;
        window.NUSA_enableAll = false;
        window.NUSA_commandBarIsDockedBottom = false;
    };
    // hook called on processing completed
    window.NUSA_lastValueUpdated = '';
    window.NUSA_activeElementName = null;
    window.NUSA_isProcessingInprogress = false;
    window.NUSA_LastRecordedTimeStamp = 0;
    window.NUSA_onProcessingStartedForElement = function (element) {
        setNuanceState('RECORDING');
        element.focus();
        element.onblur = window?.NUSA_onBlurTheElement;
        window.NUSA_activeElementName = element?.name;
        window.NUSA_isProcessingInprogress = true;
        window.NUSA_LastRecordedTimeStamp = new Date().getTime();
    };
    
    window.NUSA_onRecordingStopped = function () {
        setNuanceState('ACTIVE');
        window.NUSA_activeElementName = null;
        let currentFocusedElement = document.activeElement;
        if (currentFocusedElement && currentFocusedElement?.dataset &&
            currentFocusedElement?.dataset?.nusaEnabled) {
            window?.NUSA_onBlurTheElement(currentFocusedElement);
        }
    };
    
    window.NUSA_onBlurTheElement = function (eventOrElement) {
        if (
            (document.getElementById('NUSAI_CommandBar_Container') &&
            document.getElementById('NUSAI_CommandBar_Container').querySelectorAll('.NUSAI_CommandBar_Record_On').length > 0)
        ) {
            let element = eventOrElement?.target ? eventOrElement?.target : eventOrElement;
            if (!element?.classList.contains('ignore-nuance-update')) {
                let newValue = element.value+' ';
                window?.setNativeValue(element, (newValue));
                element.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
    }
    
    window.NUSA_handleTextAreaHeight = function (element) {
        let textareaDefaultHeight = 44;
        element.style.height = textareaDefaultHeight + "px";
        let scrollHeight = element.scrollHeight;
        element.style.height = (!scrollHeight ? textareaDefaultHeight : scrollHeight) + "px";
    }

    window.NUSA_onProcessingFinishedForElement = function (element) {
        if (window?.nuanceCallback && typeof window?.nuanceCallback[element?.name] === 'function') {
            window?.nuanceCallback[element?.name](element);
        } else {
            window?.NUSA_onBlurTheElement(element);
        }
        window?.NUSA_handleTextAreaHeight(element);
        window.NUSA_activeElementName = null;
        window.NUSA_isProcessingInprogress = false;
        window.NUSA_LastRecordedTimeStamp = new Date().getTime();
    };
    
    window.NUSA_onInit = function () {
        try {
            if (typeof window?.NUSA_initializeVuiForm !='undefined' && !window?.NUSA_initializeVuiForm()) {
                window?.NUSA_reinitializeVuiForm();
            }
        } catch(err) {
            console.warn(err);
        }
    };

    window.setNativeValue = function (element, value) {
        const { set: valueSetter } = Object.getOwnPropertyDescriptor(element, 'value') || {};
        const prototype = Object.getPrototypeOf(element);
        const { set: prototypeValueSetter } = Object.getOwnPropertyDescriptor(prototype, 'value') || {};
        if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
            prototypeValueSetter.call(element, value);
        } else if (valueSetter) {
            valueSetter.call(element, value);
        } else {
            throw new Error('The given element does not have a value setter');
        }
    }

    window.startInitializingNuance = function () {
        window.NUSAI_isButtonDeviceSupported = function () {
            return false;
        }
        setTimeout(() => {
            if (!isNuanceEnabled()) {
                window?.NUSA_onInit();
            }
        }, 5000);
    }

    window.removeNuanceTags = function (domHead) {
        let domTags = domHead?.children;
        if (domHead && domTags && domTags?.length) {
            for(let i = 0; i < domHead?.children?.length; i++) {
                if (domHead?.children[i]?.src?.indexOf('nuance') > -1 || domHead?.children[i]?.href?.indexOf('nuance') > -1) {
                    domHead?.children[i]?.remove();
                }
            }
        }
    }
    window.reloadNuanceScripts = function () {
        let domHead = document?.head;
        window?.removeNuanceTags(domHead);
        setTimeout(() => {
            window?.removeNuanceTags(domHead);
            let nuanceScriptTag = document?.createElement('script');
            nuanceScriptTag.src = "https://speechanywhere.nuancehdp.com/Mainline/scripts/Nuance.SpeechAnywhere.js";
            nuanceScriptTag.onload = function () {
                window?.startInitializingNuance();              
            };
            if (domHead) {
                domHead.appendChild(nuanceScriptTag);
            }
        }, 2000);
    }

    if (user && user.practice) {
        document.cookie = "NUSA_Guids=" + user.practice.nuance_org_token + "/" + user.practice.nuance_org_id;
    }

    window?.NUSA_configure();
}

window.documateProcessableItems = [];
(window?.navigator || navigator).mediaDevices.getUserMedia({audio: true})
.then(function (stream) {
    if (stream?.getAudioTracks()?.length > 0){
        setTimeout(() => {
            window?.reloadNuanceScripts && window?.reloadNuanceScripts();
        }, 5000);
    } else {
        alert("Please Allow Access to Your Microphone for Dictation!")
    }
})
.catch(function (error) { 
    console.error(error);
});

window.enable_log_sql = null;